@for (position of element.positionsWithAccess; track $index) {
  <app-text-overflow-label [text]="position.name"></app-text-overflow-label>
}
@for (positionGroup of element.positionGroupsWithAccess; track $index) {
  <app-text-overflow-label [text]="positionGroup.name"></app-text-overflow-label>
}
@for (role of element.rolesWithAccess; track $index) {
  <app-text-overflow-label [text]="role.name"></app-text-overflow-label>
}
